import React, { useEffect, useRef, useState } from "react";

const MarketMiniSparkline = React.memo(({ isPositive, chartData: propChartData }) => {
  const [chartData, setChartData] = useState([]);
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth <= 767);
  const canvasRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (propChartData && Array.isArray(propChartData) && propChartData.length > 0) {
      setChartData(propChartData);
    }
  }, [propChartData]);

  const canvasWidth = isMobile ? 100 : 160;
  const canvasHeight = isMobile ? 40 : 50;
  const styleHeight = isMobile ? "45px" : "60px";

  useEffect(() => {
    if (!canvasRef.current || chartData.length === 0) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { width, height } = canvas;
    ctx.clearRect(0, 0, width, height);

    const min = Math.min(...chartData);
    const max = Math.max(...chartData);
    const range = max - min || 1;

    ctx.beginPath();
    ctx.strokeStyle = isPositive ? "#00c853" : "#ff5252";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    const padding = isMobile ? 3 : 5;
    const verticalPadding = isMobile ? 8 : 15;

    chartData.forEach((price, index) => {
      const x = (index / (chartData.length - 1)) * width;
      const y = height - ((price - min) / range) * (height - verticalPadding) - padding;
      if (index === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    });
    const lastX = ((chartData.length - 1) / (chartData.length - 1)) * width;
    ctx.lineTo(lastX, height);
    ctx.lineTo(0, height);
    ctx.closePath();
    const gradient = ctx.createLinearGradient(0, 0, 0, height);
    if (isPositive) {
      gradient.addColorStop(0, "rgba(0, 200, 83, 0.3)");
      gradient.addColorStop(1, "rgba(0, 200, 83, 0)");
    } else {
      gradient.addColorStop(0, "rgba(255, 82, 82, 0.3)");
      gradient.addColorStop(1, "rgba(255, 82, 82, 0)");
    }
    ctx.fillStyle = gradient;
    ctx.fill();

    ctx.beginPath();
    ctx.strokeStyle = isPositive ? "#00c853" : "#ff5252";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    chartData.forEach((price, index) => {
      const x = (index / (chartData.length - 1)) * width;
      const y = height - ((price - min) / range) * (height - verticalPadding) - padding;
      if (index === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    });
    ctx.stroke();
  }, [chartData, isMobile, isPositive]);

  if (chartData.length === 0) {
    return (
      <img
        src="/images/trade_vector2.svg"
        className="img-fluid"
        alt="chart"
        style={{
          filter: isPositive ? "none" : "hue-rotate(180deg) saturate(1.5)",
          opacity: 0.5,
        }}
      />
    );
  }

  return (
    <canvas
      ref={canvasRef}
      width={canvasWidth}
      height={canvasHeight}
      style={{ width: "100%", height: styleHeight }}
    />
  );
});

MarketMiniSparkline.displayName = "MarketMiniSparkline";
export default MarketMiniSparkline;
